import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from 'src/environments/environment';

export const requestInterceptor: HttpInterceptorFn = (req, next) =>
  next(
    req.clone({
      withCredentials: !environment.keycloakEnabled,
      headers: req.headers.set('TimeZone-Offset', `${new Date().getTimezoneOffset()}`),
    })
  );
